// Module
var code = "<wf-affect-list form=\"$ctrl.form\" kid=\"$ctrl.kid\" ng-disabled=\"$ctrl.form.readOnly || !$ctrl.form.params.editableTabWF || !$ctrl.form.params.editable\" model-actions=\"$ctrl.form.submission.wf\" ng-model=\"$ctrl.form.workflow\"></wf-affect-list> ";
// Exports
export default code;